import type { ElementType } from 'react';
import styled, { css, keyframes } from 'styled-components';

import { SmallParagraph } from '@genially/design-system';

const floatUp = keyframes`
  0% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    transform: translateY(-180px) scale(1.2);
    opacity: 0;
  }
`;

export const Wrapper = styled.div({
  position: 'absolute',
  inset: 0,
  pointerEvents: 'none',
  zIndex: 10,
  overflow: 'hidden',
});

const withFloatUp = (Component: ElementType) =>
  styled(Component)(
    () =>
      css`
          animation: ${floatUp} 1.8s ease-out forwards;
        `,
  );

export const FloatingReactionWrapper = withFloatUp(
  styled.div<{ $left: number; $bottom: number }>(
    ({ theme: { size }, $left, $bottom }) => ({
      position: 'absolute',
      bottom: `${$bottom}%`,
      left: `${$left}%`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: size.units(0.5),
    }),
  ),
);

export const EmojiImage = styled.img(({ theme: { size } }) => ({
  width: size.units(5.5),
  height: size.units(5.5),
  objectFit: 'contain',
  userSelect: 'none',
}));

export const PlayerNameWrapper = styled.div(({ theme: { color, size } }) => ({
  backgroundColor: color.background.reversed.default(0.7),
  padding: `${size.units(0.5)} ${size.units(1)}`,
  borderRadius: size.units(10),
}));

export const PlayerName = styled(SmallParagraph)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));
